import { triadSuperFetch } from 'utils/superFetch';
import { Redis, Memory, Cookie } from '../common/Icons';
import styles from '../ConfigModal.module.css';

export function CacheSection(): React.JSX.Element {
  function handleClearSessionCache(): void {
    localStorage.clear();
    sessionStorage.clear();
  }

  function handleClearLocalCookies(): void {
    document.cookie.split(';').forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });
  }

  async function handleClearRedisCache(): Promise<void> {
    await triadSuperFetch('/api/redis/clear-key', {
      method: 'GET',
      timeout: 3000,
      queryParams: { key: 'all' },
    });
  }

  return (
    <section className={styles.section}>
      <div className={styles.buttonGroup}>
        <button
          className={styles.actionButton}
          type="button"
          onClick={handleClearRedisCache}
        >
          <Redis />
          <span>Redis Cache</span>
        </button>
        <button
          className={styles.actionButton}
          type="button"
          onClick={handleClearSessionCache}
        >
          <Memory />
          <span>Clear Session Cache</span>
        </button>
        <button
          className={styles.actionButton}
          type="button"
          onClick={handleClearLocalCookies}
        >
          <Cookie />
          <span>Clear Local Cookies</span>
        </button>
      </div>
      <div className={styles.buttonContainer}>
        <button
          type="button"
          className={styles.updateButton}
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </button>
      </div>
    </section>
  );
}
